export default __webpack_public_path__ + "static/media/image3.21d60904.jpg";